<template>
    <tr :class="index % 2 === 0 ? 'row-odd' : 'row-even'">
        <td class="td-padding">
            <input :checked="checked"
                   class="check-bulk"
                   type="checkbox"
                   @change="$emit('checked', {value: document.id, checked: $event.target.checked})">
        </td>
        <td class="td-padding">{{ document.date_issued }}</td>
        <td class="td-padding">{{ document.translated_full_document_type }}</td>
        <td class="td-padding text-wrap" style="word-break: break-all">{{ document.document_number }}</td>
        <td class="td-padding text-wrap">{{ document.remarks }}</td>
        <td class="td-padding text-right">{{ document.net_amount }}</td>
        <td class="td-padding text-right">{{ document.gross_amount }}</td>
        <td class="td-padding">{{ document.currency }}</td>
        <td class="text-right table-icons">
            <DocumentStatusLabel :document="document" :status="document.status"/>
            <TableIcon
                v-if="document.download_scan_route"
                :href="document.download_scan_route"
                :title="__('download_file')"
                icon="fa-paperclip"
                target="_blank"
            />
            <TableIcon
                v-if="document.download_pdf_route"
                :href="document.download_pdf_route"
                :title="__('download_file')"
                icon="fa-paperclip"
                target="_blank"
            />
        </td>
    </tr>
</template>

<script>
import DocumentStatusLabel from "../../../DocumentStatusLabel";
import TableIcon from "../../../table/TableIcon";
import hasPermissions from "../../../../mixins/hasPermissions";
import hasTooltips from "../../../../mixins/hasTooltips";
import inputEmit from "../../../../mixins/inputEmit";
import hasErrors from "../../../../mixins/hasErrors";

export default {
    name: "ContractConnectDocumentTableRow",
    components: {TableIcon, DocumentStatusLabel},
    props: {
        document: {
            type: Object,
            required: true,
        },
        checked: {
            type: Boolean,
            default: false,
        },
        index: {
            type: Number,
            required: true,
        },
    },
    mixins: [hasPermissions],
};
</script>
